import TahunAjaran from "../../../../../components/categories/siakad/lms/data_tahun_ajaran/Home";
export default function Home() {
  
  return (
    <TahunAjaran />
  );
}
